import Vue from 'vue'
import Router from 'vue-router'
import {Home} from '@/layout'

import store from '@/store'
import {setTitle} from "@/utils";
import hasPermission from "@/directive/permission";
import modules from './modules';

Vue.use(Router);

let routes = [
    {
        path: '/',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('@/page/index'),
            }
        ]
    },
    {
        path: '/activity',
        component: Home,
        children: [
            {
                path: '',
                meta: {
                    title: '社区活动'
                },
                component: () => import('@/page/activity')
            }
        ]
    },
    {
        path: '/found',
        component: Home,
        children: [
            {
                path: '',
                meta: {
                    title: '发现'
                },
                props: route => ({value: route.query}),
                component: () => import('@/page/found')
            }
        ]
    },
    {
        path: '/work',
        component: Home,
        children: [
            {
                path: '',
                props: (route) => (Object.assign({}, route.params, route.query)),
                component: () => import('@/page/work')
            }
        ]
    },
    {
        path: '/mobile',
        props: (route) => ({ wid: route.query.wid }),
        component: () => import('@/page/work/mobile')
    },
    {
        path: '/scratch',
        props: (route) => ({ wid: route.query.wid }),
        meta: {
            title: '图形化编程'
        },
        component: () => import('@/page/editor/Scratch')
    },
    {
        path: '/python',
        props: (route) => ({ wid: route.query.wid }),
        meta: {
            title: 'Python在线编辑器'
        },
        component: () => import('@/page/editor/Python')
    },
    {
        path: '/notice',
        component: Home,
        children: [
            {
                path: '',
                meta: {
                    title: '网站通知'
                },
                component: () => import('@/page/notice')
            }
        ]
    },
    {
        path: '/view',
        props: (router) => ({url: router.query.url}),
        component: () => import('cps/views/OfficeView')
    },
    {
        path: '/error',
        component: Home,
        children: [
            {
                path: '404',
                meta: {
                    title: '404'
                },
                component: () => import('@/page/error/NotFound')
            }
        ]
    }
];

const router = new Router({
    mode: 'history',
    base: '/',
    routes
});

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 */
function filterAsyncRouter(asyncRouterMap) {
    // 返回满足条件的子路由对象
    return asyncRouterMap.filter(route => {
        if (route.meta && hasPermission(route.meta.roles)) {
            if (route.children && route.children.length && route.meta.childrenRoles) {
                // route.children重新过滤赋值;
                route.children = filterAsyncRouter(route.children)
            }
            return true // 返回该权限路由对象;
        }
        return false
    })
}

router.beforeEach((to, from, next) => {
    store.commit('SET_TITLE', to.meta.title);
    if (!store.getters.initRouter) {
        let routes = [{path: '*', redirect: '/error/404'}];
        if (store.getters.is_login) {
            routes = filterAsyncRouter(modules).concat(routes);
        }
        router.addRoutes(routes);
        store.commit('SET_INIT_ROUTER');
        next({...to, replace: true});
    }
    next();
});

router.afterEach(() => {
    setTimeout(() => {
        setTitle(store.getters.title);
    }, 0)
});

export default router;
